import { render } from "./ControlWrapper.vue?vue&type=template&id=d6c3a63e&ts=true"
import script from "./ControlWrapper.vue?vue&type=script&lang=ts"
export * from "./ControlWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__